"use client";
import React from "react";
import QRCode from "react-qr-code";
import classNames from "classnames";
import { useTranslations } from "next-intl";
import { useMutation, useQuery } from "@tanstack/react-query";

import { Button, Input, Loader, Modal } from "@/components/common";
import { QRCodeIcon, RefreshIcon } from "@/components/assets/icons";
import { useModal } from "@/hooks/useModal";

import { ButtonColor } from "@/enums";
import { apiRequest } from "@/utils/apiRequest";

import {
  GET_QR_PICKUP_CODE,
  REGENERATE_QR_PICKUP_CODE,
} from "@/constants/Query";

const ScanQrCode = () => {
  const t = useTranslations();

  const { openModal, modalOpen, closeModal } = useModal();

  const { data, isLoading, refetch } = useQuery<{
    data: {
      data: {
        pickupCode: string;
      };
    };
  }>({
    queryKey: [GET_QR_PICKUP_CODE],
    queryFn: () => apiRequest(GET_QR_PICKUP_CODE, "get"),
  });

  const { mutateAsync: regeneratePickupCode } = useMutation({
    mutationFn: () => apiRequest(REGENERATE_QR_PICKUP_CODE, "put"),
  });

  const handleRegeneratePickupCode = async () => {
    try {
      await regeneratePickupCode();
      refetch();
    } catch (error) {
      console.error("Error", error);
    }
  };

  const pickupCode = data?.data?.data?.pickupCode;

  return (
    <>
      <div
        onClick={pickupCode ? openModal : undefined}
        className={classNames(
          "relative flex h-[50px] w-auto cursor-pointer items-center justify-between gap-2 rounded-[25px] border border-dashed border-[#73B76F] bg-[#eef4ee] p-2",
          {
            "!cursor-not-allowed opacity-50": !pickupCode,
          },
        )}
      >
        <div className="flex h-[38px] w-[38px] items-center justify-center rounded-[40px] bg-white">
          <QRCodeIcon />
        </div>
        <div className="absolute right-0 top-0 h-[13px] w-[13px] rounded-full border border-white bg-[#73B76F]" />
        <p className="text-sm font-bold uppercase text-[#73B76F]">
          {t("scan_qr")}
        </p>
      </div>
      <Modal
        title="qr_modal_title"
        isOpen={modalOpen}
        closeModal={closeModal}
        paddings="!p-0"
        showCloseIcon
      >
        <div className="flex w-[500px] flex-col items-center justify-center pt-[18px]">
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <QRCode value={pickupCode} size={230} />
              <Input
                containerClassName="w-full mt-[46px] mb-[30px] max-w-[229px]"
                className="!text-black"
                label="receiving_code"
                name="receiving_code"
                type="text"
                disabled
                onChange={() => {}}
                value={pickupCode}
              />
              <div className="w-full border-t px-[30px] pb-[42px] pt-[30px]">
                <Button
                  disabled={isLoading}
                  onClick={handleRegeneratePickupCode}
                  color={ButtonColor.SECONDARY}
                >
                  <div className="flex items-center gap-1">
                    <RefreshIcon />
                    {t("refresh_code")}
                  </div>
                </Button>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export { ScanQrCode };
